import claim from './claim'
import notification from './notification'

export default (Bus) => {
  claim(Bus)
  notification(Bus)
}
